import { client } from '../http';

async function getFlowConfigByFlowId(flowId) {
  const response = await client.get(`/api/no-auth/ots-flow-config/${flowId}`);
  const { data } = response;
  return data;
}

export default {
  getFlowConfigByFlowId,
};
